<template>
  <div class="operate_box">
    <div class="play_count_box" v-if="playCount>=10000">
      <div class="view_icon">
        <van-icon name="eye" />
        <div v-text="playCount"></div>
      </div>
    </div>
    <div class="praise_icon_box" v-if="allowLike != false && allowLike != 0">
      <div :class="{praise:true,praised:isLiked}">
        <van-icon name="like" @click="cancelPraiseHandler()" v-if="isLiked == true"/>
        <van-icon name="like" @click="praiseHandler()" v-else/>
        <div v-text="topCount"></div>
      </div>
    </div>
    <div class="comment_icon_box">
      <div class="comment_icon" @click="viewComments($event)">
        <van-icon name="chat" />
        <div>评论</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { addScore } from "@/utils";
import commApi from "@/api/apis/common.js";
export default {
  name: "Operate",
  props: {
    params: {
      type: Object,
      default: null,
    },
    id: {
      type: Number,
      default: null,
    },
    playCount: {
      type: Number,
      default: 0,
    },
    contentTitle: {
      type: String,
      default: "",
    },
    allowLikes: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    ...mapState("app", ["userInfo", "deviceId"]),
  },
  data() {
    return {
      topCount: 0,
      allowLike: true,
      isLiked: false, // 是否已点赞
    };
  },
  watch: {
    allowLikes: {
      handler(newValue, oldValue) {
        this.allowLike = newValue;
      },
      deep: true,
    }
  },
  methods: {
    /* 获取点赞状态 */
    getThumbsUpStatus() {
      var _this = this;
      var params = {
        contentType: _this.params.contentType,
        contentId: _this.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }
      commApi
        .queryThumbsUpStatus(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.topCount = res.data.topCount;
            if (res.data.userLikes == 1) {
              _this.isLiked = true;
            }
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 点赞 */
    praiseHandler() {
      var _this = this;

      var params = {
        contentType: _this.params.contentType,
        contentId: _this.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }

      commApi
        .giveThumbsUp(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.isLiked = true;
            _this.topCount++;
            _this.addScore(); // 增加积分
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 取消点赞 */
    cancelPraiseHandler() {
      var _this = this;

      var params = {
        contentType: _this.params.contentType,
        contentId: _this.id,
        fromFlag: _this.params.fromFlag,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }

      commApi
        .cancelThumbsUp(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.isLiked = false;
            _this.topCount--;
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 显示所有评论 */
    viewComments(event) {
      this.$emit("showComments", true);
    },
    /* 增加积分 */
    addScore() {
      let jf_params = {
        code: "dz", // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、gkyp、zbj、dy、dz、sc)
        description: "点赞", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、观看音频、直播间、订阅、点赞、收藏)
        contentType: this.params.contentType, // 非必传，稿件的type
        contentId: this.params.contentId, // 非必传，稿件的id
        contentName: this.contentTitle, // 非必传，稿件的标题
      }
      if (!!this.userInfo) {
        jf_params = Object.assign(jf_params, {
          memberId: this.userInfo.id, //会员id
        });
      }
      addScore(jf_params);
    },
  },
  created() {
    this.allowLike = this.allowLikes;
    this.getThumbsUpStatus(); //获取点赞状态
  },
};
</script>
<style scoped lang="scss">
.operate_box {
  position: absolute;
  right: 3%;
  bottom: 9%;
  .play_count_box {
    margin-bottom: 10px;
    .view_icon {
      text-align: center;
      color: #fff;
      font-size: 12px;
      .van-icon {
        font-size: 30px;
      }
    }
  }
  .praise_icon_box {
    margin-bottom: 10px;
    .praise {
      text-align: center;
      color: #fff;
      font-size: 12px;
      &.praised {
        color: #dc1e06;
      }
      .van-icon {
        font-size: 30px;
      }
    }
  }
  .comment_icon_box {
    margin-bottom: 10px;
    .comment_icon {
      text-align: center;
      color: #fff;
      font-size: 12px;
      .van-icon {
        font-size: 30px;
      }
    }
  }
}
</style>